import { Component, OnInit } from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector'
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent extends AbstractBiditComponent implements OnInit {
  public deviceInfo = null;
  public isTablet = false;
  public isDesktop = false;

  constructor(private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
  }

  ngOnInit() {
  }

}
